import React, {PropTypes} from "react"
import { Form, Row } from "antd"
import "./materialFormItem.scss"
import validateMsg from "app/utils/validateMsg.js"
import cx from "classnames"

const FormItem = Form.Item
export default class MaterialFormItem extends React.Component {
  render() {
    let { labelText, justify, labelWidth, tipMsgType, inputType, className, ...rest,  } = this.props
    let tipMsg
    if (tipMsgType && inputType) {
      tipMsg = validateMsg[inputType][tipMsgType]
    }
    const FormItemClass = cx({
      "pgx-form-item": true,
      [className]: className,
    })
    const success = !tipMsgType
    return (
      <FormItem
        label={(
          <b style={{width:labelWidth, display: "inline-block"}}>{labelText}</b>
        )}
        className={FormItemClass}
        validateStatus={ success ? "success" : "error" }
        {...rest}
      >
        <Row type="flex" justify={justify} align="middle">
          {this.props.children}
          {
            !success && (
              <div className="legitimacyTip">
                {tipMsg}
              </div>
            )
          }
        </Row>
      </FormItem>
    )
  }
}

MaterialFormItem.propTypes = {
  justify: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  labelWidth: PropTypes.number
}

MaterialFormItem.defaultProps = {
  labelWidth: 70,
  justify: "center"
}



// WEBPACK FOOTER //
// ./src/app/components/normal/MaterialFormItem/MaterialFormItem.js